import moment from 'moment';
import { format, parse } from 'date-fns';

export const COMPACT_DATE_FORMAT = 'YYYYMMDDHHmm';

const getlength = (number: number) => number.toString().length;
const getMonth = (month: number) => (getlength(month) < 2 ? `0${month}` : `${month}`);

export const dateStandardFormat = (date: Date) => format(date, 'dd/MM/yyyy');
export const getHour = (date: Date) => format(date, 'p');

export const dateToString = (value: any) => {
    const date = new Date(value);
    const day = date.getDate();
    const month = getMonth(date.getMonth() + 1);
    const year = date.getFullYear();
    return `${year}${month}${day}`;
};

export const parseToDate = (value: string, formats: string[]): Date | undefined | null => {
    const validFormat = formats.find((format) => !isNaN(parse(value, format, new Date()).getTime()));
    if (!validFormat) return null;
    return parse(value, validFormat, new Date());
};

export const toCompactDate = (value: any): string => moment(value).format('YYYYMMDDHHmm') ?? '';

export const parseToMoment = (
    raw: any,
    acceptFormats: readonly string[],
    acceptISO?: boolean
): moment.Moment | null => {
    if (raw == null || raw === '') return null;
    if (moment.isMoment(raw)) return raw;

    if (raw instanceof Date) {
        return isNaN(raw.getTime()) ? null : moment(raw);
    }

    if (typeof raw === 'string') {
        const cleaned = raw.trim().replace('[UTC]', '');
        if (!cleaned) return null;

        // Strict parse against allowed custom formats
        const strict = moment(cleaned, acceptFormats as any, true);
        if (strict.isValid()) return strict;

        // Strict ISO
        if (acceptISO) {
            const iso = moment(cleaned, moment.ISO_8601, true);
            if (iso.isValid()) return iso;
        }

        return null;
    }

    return null;
};
